function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React from 'react';
import classes from './storeCheckoutLocatorModal.css';
import TextInput from "../../TextInput";
import { useIntl } from 'react-intl';
import { sendGTMEvent } from "../../../util/initGTM";
var PlacesWithStandaloneSearchBox = props => {
  var {
    inputLocationRef,
    placePredictions,
    searchString,
    setSearchString,
    triggerSearch,
    fromPage
  } = props;
  var {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.autocompleteContainer
  }, /*#__PURE__*/React.createElement(TextInput, {
    currentRef: inputLocationRef,
    style: {
      //to unset default styling
      borderRight: '1px solid black'
    },
    className: classes.input,
    defaultValue: searchString,
    onChange: e => {
      var value = e.target.value;
      setSearchString(value);
    },
    onKeyDown: /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (e) {
        if (e.key === "Enter") {
          yield triggerSearch(e);
        }
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    onFocus: () => {
      switch (fromPage) {
        case 'checkout':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Select Other Store Overlay',
              eventLabel: 'Field: Enter location',
              event: 'genericGAEvent'
            });
            break;
          }
      }
    },
    placeholder: formatMessage({
      defaultMessage: 'Enter City, Province or Postal Code',
      id: 'storeSchedule.mapSearchPlaceholder'
    })
  }), placePredictions && placePredictions.length && inputLocationRef && inputLocationRef.current && document.activeElement === inputLocationRef.current ? /*#__PURE__*/React.createElement("div", {
    className: classes.autocompletePopup
  }, placePredictions.map((place, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.autocompletePlace,
      onClick: e => Promise.resolve().then(() => setSearchString(place.description)).then(() => triggerSearch(e, index))
    }, /*#__PURE__*/React.createElement("p", null, place.description));
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.googleCopyright
  }, /*#__PURE__*/React.createElement("p", null, "Powered by"), /*#__PURE__*/React.createElement("img", {
    src: "https://maps.gstatic.com/mapfiles/api-3/images/google4.png",
    alt: 'google copyright'
  }))) : null);
};
export default PlacesWithStandaloneSearchBox;